import AsControl from '../AsControl';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import PureTransfer from './Transfer';

export const Transfer = AsControl()(PureTransfer);
export const TransferControl = bindControlToForm()(Transfer);
